type Call = {
  sig: string;
  title: string;
  why: string;
  pill: string;
  pillTone: 'accent' | 'warn';
};

const CALLS: Call[] = [
  {
    sig: 'Diligence · financials',
    title: 'The investment call',
    why: 'Conditional — significant remediation required before proceeding.',
    pill: 'Proceed, with conditions',
    pillTone: 'accent',
  },
  {
    sig: 'People · key-person risk',
    title: 'Head of Data is a single point of failure',
    why: 'Risk score 75/100 — flagged as SPOF, long-tenured with few senior peers, five documented dependencies.',
    pill: 'Mitigate now',
    pillTone: 'warn',
  },
  {
    sig: 'Financial · covenant',
    title: 'Debt Service Coverage Ratio breached',
    why: 'A loan covenant has tripped — surfaced the moment the ratio crossed, not at quarter-end.',
    pill: 'Mitigate now',
    pillTone: 'warn',
  },
];

export function SignalCall() {
  return (
    <section id="how" className="bg-bg-raised py-24 sm:py-28">
      <div className="container-page">
        <div className="mb-12 max-w-[60ch]">
          <p className="eyebrow mb-4">Signal → call</p>
          <h2 className="text-display-md leading-[1.12]">
            Every call traces back to the signal that raised it.
          </h2>
          <p className="mt-4 text-[1.05rem] text-ink-muted">
            Claros watches the numbers so you don't have to. When something
            crosses a line, it becomes a decision on your desk — with the
            rationale and the conditions to proceed already written.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CALLS.map((c) => (
            <article
              key={c.title}
              className="flex flex-col gap-3.5 rounded-2xl border border-border bg-bg-surface px-6 pb-6 pt-7 transition hover:-translate-y-1 hover:shadow-panel-sm"
            >
              <span className="font-mono text-[11px] uppercase tracking-[0.11em] text-ink-faint">
                {c.sig}
              </span>
              <h3 className="text-[1.24rem]">{c.title}</h3>
              <p className="text-[14.5px] leading-relaxed text-ink-muted">
                {c.why}
              </p>
              <div className="mt-auto flex items-center justify-between gap-2.5 pt-2">
                <span
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-[12.5px] font-semibold ${
                    c.pillTone === 'warn'
                      ? 'bg-signal/10 text-signal'
                      : 'bg-accent-glow text-accent-bright'
                  }`}
                >
                  {c.pill}
                </span>
                <span className="text-[13px] font-semibold text-ink-faint">
                  Review →
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
